import React from "react";
import { LegalLayout } from "@/components/LegalLayout";
import { termsSections } from "@/content/legal";
import { useLang } from "@/lib/i18n";

export default function TermsPage() {
  const { t } = useLang();
  const host = window.location.hostname;
  return (
    <LegalLayout
      testId="terms-page"
      title={t("termsOfUse")}
      updated={t("legalUpdated")}
      sections={termsSections(host)}
    />
  );
}
